import { Subscribe } from "@react-rxjs/core"

import { isMobileDevice } from "@/utils"

import { AdminButton } from "./AdminButton"
import { Latency } from "./Latency"
import { LatencyHistoricalGraph } from "./LatencyHistoricalGraph"
import { Updates } from "./Updates"
import { UpdatesHistoricalGraph } from "./UpdatesHistoricalGraph"

export const Stats = () => {
  const statsVisible = !isMobileDevice
  return statsVisible ? (
    <Subscribe>
      <div className="hidden items-center justify-center gap-md text-[0.65rem] opacity-[.59] lg:flex">
        <UpdatesHistoricalGraph />
        <Updates />
        <LatencyHistoricalGraph />
        <Latency />
        <AdminButton />
      </div>
    </Subscribe>
  ) : null
}
